<div class="modal-container">
  <h2 class="form-title" mat-dialog-title>{{data.selectedRow ? 'Edit Price Condition': 'Add Price Condition'}}</h2>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="form-grid">
    <!-- Description -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Description</mat-label>
      <input matInput formControlName="description" placeholder="Enter description" maxlength="80" />
      @if (form.get('description')?.hasError('required')) {
        <mat-error>
          Description is required
        </mat-error>
      }
      @if (form.get('description')?.hasError('maxlength')) {
        <mat-error>
          Max 80 characters
        </mat-error>
      }
    </mat-form-field>

    <!-- Variant Combination Chips with Autocomplete -->
    <mat-form-field appearance="outline" class="full-width" [ngClass]="{ 'disabled-chip-grid': isEdit }">
      <mat-label>Variant Combinations</mat-label>
      <mat-chip-grid #chipGrid [disabled]="isEdit" formControlName="variantCombination" aria-label="Variant input">
        @for (variant of selectedVariants; track variant) {
          <mat-chip-row [removable]="!isEdit" (removed)="removeVariant(variant)">
            {{variant}} <!-- {{ displayValue(variant) }} -->
            @if (!isEdit) {
              <button matChipRemove>
                <mat-icon>cancel</mat-icon>
              </button>
            }
          </mat-chip-row>
        }
      </mat-chip-grid>
      <input matInput placeholder="Add Variant" [matChipInputFor]="chipGrid" [matAutocomplete]="autoVariant"
        [formControl]="variantCtrl" (matChipInputTokenEnd)="addVariantFromInput()"
        [disabled]="isEdit || (selectedVariants?.length || 0) >= 6"
        (blur)="form.get('variantCombination')!.markAsTouched()" />

        <mat-autocomplete #autoVariant="matAutocomplete" (optionSelected)="selectVariant($event)">
          @for (option of variantSuggestions; track option) {
            <mat-option [value]="option.key"
              [disabled]=" isEdit || selectedVariants.includes(option.value)||(selectedVariants?.length || 0) >= 6">
              {{ option.value }}
            </mat-option>
          }
        </mat-autocomplete>
        @if (form.get('variantCombination')?.hasError('required')) {
          <mat-error>
          variant required</mat-error>
        }
        @if (!isEdit && selectedVariants.length > 6) {
          <mat-error>
          max 6 allowed</mat-error>
        }
      </mat-form-field>

      <!-- Price Type with value -->

      <div formArrayName="prices" class="full-width price-type-grid">
        @for (row of prices.controls; track row; let i = $index) {
          <div [formGroupName]="i" class="price-type-row">
            <!-- Price Type Dropdown -->
            <mat-form-field appearance="outline" class="type-cell">
              <mat-label>Price Type</mat-label>
              <mat-select formControlName="selectedType" [compareWith]="comparePriceType">
                @for (pt of priceTypes; track pt) {
                  <mat-option [value]="pt">
                    {{ pt.name }}
                  </mat-option>
                }
              </mat-select>
              @if (row.get('selectedType')?.hasError('required')) {
                <mat-error>
                  Price Type is required.
                </mat-error>
              }
            </mat-form-field>
            <!-- Price Value Input -->
            <mat-form-field appearance="outline" class="value-cell">
              <mat-label>Price</mat-label>
              <input matInput type="number" step="any" placeholder="Enter price" formControlName="priceValue"
                (keydown.enter)="$event.preventDefault()" required />
                @if (row.get('priceValue')?.hasError('required')) {
                  <mat-error>
                    Price is required.
                  </mat-error>
                }
              </mat-form-field>
              <!-- Remove Button -->
              @if (false) {
                <div class="actions-cell">
                  @if (prices.length > 1) {
                    <button mat-icon-button color="warn" type="button" (click)="removePriceRow(i)">
                      <mat-icon>remove_circle</mat-icon>
                    </button>
                  }
                  <!-- Add Button -->
                  @if (i === prices.length - 1) {
                    <button mat-icon-button color="primary" type="button"
                      (click)="addPriceRow()">
                      <mat-icon>add_circle</mat-icon>
                    </button>
                  }
                </div>
              }
            </div>
          }

        </div>


        <!-- Valid From -->
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Valid From</mat-label>
          <input matInput [matDatepicker]="fromPicker" [min]="minDate" formControlName="validFrom" />
          <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
          <mat-datepicker #fromPicker (opened)="onFromPickerOpened()" (closed)="onFromPickerClosed()"></mat-datepicker>
          @if (form.get('validFrom')?.hasError('min')) {
            <mat-error>Date must be greater than today</mat-error>
          }
        </mat-form-field>

        <!-- Valid To -->
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Valid To</mat-label>
          <input matInput [matDatepicker]="toPicker" [min]="minDateTo" formControlName="validTo" />
          <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
          <mat-datepicker #toPicker></mat-datepicker>
          @if (form.get('validTo')?.hasError('min')) {
            <mat-error>Date must be greater than or equal to validFrom</mat-error>
          }
        </mat-form-field>

        <!-- Buttons -->
        <div class="form-actions full-width">
          <button mat-raised-button color="primary" type="submit">Submit</button>
          <button mat-button type="button" (click)="onCancel()">Cancel</button>
        </div>
      </form>
    </div>
